module.exports = __webpack_public_path__ + "img/entertainment-1.f1e90c20.jpg";